(function () {
  var sections = document.querySelectorAll('[data-notxs-pin-scroll]');
  if (!sections.length) return;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function rafThrottle(fn) {
    var ticking = false;
    return function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        fn();
        ticking = false;
      });
    };
  }

  function setViewportHeight() {
    document.documentElement.style.setProperty('--notxs-vh', window.innerHeight + 'px');
  }

  sections.forEach(function (section) {
    var panel = section.querySelector('[data-notxs-pin-panel]');
    var viewport = section.querySelector('[data-notxs-pin-viewport]');
    var track = section.querySelector('[data-notxs-pin-track]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-notxs-pin-card]'));
    var progressBar = section.querySelector('[data-notxs-pin-progress]');

    if (!panel || !viewport || !track || !cards.length) return;

    var state = { sectionTop: 0, sectionHeight: 0, scrollLength: 0, cardWidth: 0, activeIndex: -1 };

    function setPanelState(mode) {
      panel.classList.toggle('is-fixed', mode === 'fixed');
      panel.classList.toggle('is-after', mode === 'after');
    }

    function setActiveCard(index) {
      index = clamp(index, 0, cards.length - 1);
      if (state.activeIndex === index) return;
      state.activeIndex = index;
      cards.forEach(function (card, cardIndex) {
        card.classList.toggle('is-active', cardIndex === index);
      });
    }

    function measure() {
      setViewportHeight();
      setPanelState('before');
      state.cardWidth = viewport.clientWidth;
      track.style.setProperty('--notxs-card-width', state.cardWidth + 'px');
      cards.forEach(function (card) {
        card.style.setProperty('--notxs-card-width', state.cardWidth + 'px');
      });
      state.scrollLength = Math.max(window.innerHeight, window.innerHeight * (cards.length - 1));
      state.sectionHeight = window.innerHeight + state.scrollLength;
      section.style.height = state.sectionHeight + 'px';
      state.sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
      update();
    }

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var start = state.sectionTop;
      var end = state.sectionTop + state.scrollLength;
      var progress;

      if (y < start) {
        progress = 0;
        setPanelState('before');
      } else if (y >= end) {
        progress = 1;
        setPanelState('after');
      } else {
        progress = clamp((y - start) / state.scrollLength, 0, 1);
        setPanelState('fixed');
      }

      var rawIndex = progress * (cards.length - 1);
      var index = Math.round(rawIndex);
      var translateX = state.cardWidth * index;

      track.style.transform = 'translate3d(' + (-translateX) + 'px, 0, 0)';

      if (progressBar) {
        progressBar.style.transform = 'scaleX(' + progress + ')';
      }

      setActiveCard(index);
    }

    var throttledMeasure = rafThrottle(measure);
    var throttledUpdate = rafThrottle(update);

    window.addEventListener('scroll', throttledUpdate, { passive: true });
    window.addEventListener('resize', throttledMeasure);
    window.addEventListener('orientationchange', function () {
      setTimeout(measure, 300);
    });

    if (window.ResizeObserver) {
      var observer = new ResizeObserver(throttledMeasure);
      observer.observe(section);
      observer.observe(viewport);
      observer.observe(track);
    }

    var images = section.querySelectorAll('img');
    images.forEach(function (image) {
      if (!image.complete) {
        image.addEventListener('load', throttledMeasure, { once: true });
        image.addEventListener('error', throttledMeasure, { once: true });
      }
    });

    document.addEventListener('DOMContentLoaded', throttledMeasure);
    window.addEventListener('load', throttledMeasure);

    setTimeout(measure, 80);
    setTimeout(measure, 400);
    setTimeout(measure, 1000);
  });
})();